import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  cardWrapper: {
    display: 'flex',
    flexDirection: {
      xs: 'row',
      md: 'unset',
    },
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: {
      xs: '16px',
      md: '24px',
    },
    flexBasis: { xs: '100%', md: '100%' },
    overflow: 'auto',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    paddingBottom: '12px',
  },
  actionButton: {
    alignSelf: 'center',
    mt: { xs: '20px', md: '32px' },
    whiteSpace: 'pre',
  },
  featureCardWrapper: {
    // flexBasis: {
    //   xs: '100%',
    //   sm: '32%',
    // },
  },
  accordionImage: {
    height: '504px',
    width: {
      xs: 'unset',
      md: '540px',
    },
    borderRadius: '16px',
  },
  image: { height: '320px', width: '100%', borderRadius: '16px' },

  accordion: {
    backgroundColor: 'background.paper',
    padding: '24px',
  },
  accordionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'red',
    gap: '16px',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  documentWrapper: {
    fontSize: '14px',
    '& p': {
      margin: '0px',
      color: 'text.secondary',
    },
  },
  businessCard: {
    justifyContent: 'unset',
    height: 'unset',
  },
  accordionSectionWrapper: {
    display: 'flex',
    gap: {
      xs: '40px',
      sm: '20px',
    },
    flexDirection: {
      xs: 'column-reverse',
      md: 'row',
    },
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
